<div>
  <div class="ui input icon">
    <input type="time" 
          name="suitimepicker" 
          [(ngModel)]="inputValue"
          (blur)="onBlur($event)"
          (keydown)="onKeydown($event)">
    <i class="remove link icon" [class.hidden-remove]="showRemove()" (click)="removeOnClick($event)"></i>
  </div>
</div>